import React, { createContext, useState } from "react"
import { get, post, put } from "utils/apiClient"


const ApptReqCfgDetailContext = createContext()


function Provider({ children }) {
    const api_url = process.env.REACT_APP_API_URL

    const [apptSysTypes, setApptSysTypes] = useState([])
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [msg, setMsg] = useState()
    const [locationsByApptSys, setLocationsByApptSys] = useState([])
    const [locConfig, setLocConfig] = useState()

    const fetchAllApptSys = async (search_term) => {
        setLoading(true)
        let response = null
        try {
          const url = search_term ? 'appt-sys/all?search_term=' + search_term : 'appt-sys/all'
          response = await get(url)
          console.log(response)
          setApptSysTypes(response)
          setLoading(false)
        } catch (error) {
          console.error(error)
          setLoading(false)
        }
    
    }

    const fetchAllLocForApptSys = async (apptSysType) => {
        setLoading(true)
        try {
          const response = await get('appt-req-cfg/locations?appt_sys_type='+apptSysType)
          
          let result = response?.sort((a, b) =>
            a.m_loc_nm.localeCompare(b.m_loc_nm)
          )
          setLoading(false)
          setLocationsByApptSys(result)
    
    
        } catch (error) {
          console.error(error)
          setLoading(false)
        }
    }

    const fetchAllLocConfig = async (appt_sys_type) => {
        try {
            setLoading(true)
            const response = await get('appt-req-cfg?appt_sys_type=' + appt_sys_type)
            setLocConfig(response)
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    const updateConfig = async (obj) => {
      setLoading(true)
      try{
        const response = await put('appt-req-cfg', obj)
        setSuccess(true)
        setLoading(false)
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }


    const createConfig = async (obj) => {
      setLoading(true)
      try{
        const response = await post('appt-req-cfg', obj)
        setSuccess(true)
        setLoading(false)
      } catch (error) {
        setError(true)
        console.error(error)
        setLoading(false)
      }
    }

    const valueToShare = {
        loading,
        success,
        setSuccess,
        apptSysTypes,
        fetchAllLocForApptSys,
        fetchAllLocConfig,
        updateConfig,
        createConfig,
        locationsByApptSys,
        locConfig,
        error,
        setError,
        msg,
      }
    
      return (
        <ApptReqCfgDetailContext.Provider value={valueToShare}>{children}</ApptReqCfgDetailContext.Provider>
      )
}


export { Provider }
export default ApptReqCfgDetailContext

